import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=3f0bb4cf&scoped=true"
import script from "./ui-button.vue?vue&type=script&lang=js"
export * from "./ui-button.vue?vue&type=script&lang=js"
import style0 from "./ui-button.vue?vue&type=style&index=0&id=3f0bb4cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0bb4cf",
  null
  
)

export default component.exports